"use strict";
import axios from "axios";

const url = "temps.json";

export async function getTemps() {
  let temps;
  try {
    temps = await axios.get(url);
    console.log("got temps: " + JSON.stringify(temps, null, 2));
  } catch (error) {
    console.log("Error reading temps: " + error);
  }

  if (temps && temps.data) {
    return temps.data;
  }

  return undefined;
}
